<template>
  <el-card shadow="hover">
    <label slot="header">行业选择器</label>
    <el-divider content-position="left">value-type="String" separator="/": {{industrySelect}}</el-divider>
    <JIndustry type="select" value-type="String" separator="/" v-model="industrySelect" placeholder="请选择行业" />
    <el-divider content-position="left">change返回值数组:{{keyArray}}|{{textArray}}</el-divider>
    <JIndustry type="select" value-type="Array" v-model="industryArray" placeholder="请选择行业" @change="industryChange" />
    <el-divider content-position="left">文本解析 text-separator="#" 以#分隔显示</el-divider>
    <JIndustry text-separator="#" :value="industryStr" />
  </el-card>
</template>

<script>
import JIndustry from "@/components/JComponents/JIndustry/JIndustry.vue";
export default {
  components: {
    JIndustry
  },
  data() {
    return {
      industryStr: 'A,02',
      industrySelect: '',
      industryArray: '',
      keyArray: [],
      textArray: []
    }
  },
  methods: {
    industryChange (keyArray, textArray) {
      console.log(keyArray, textArray)
      this.keyArray = keyArray
      this.textArray = textArray
    }
  }
}
</script>
